import { FC, useMemo, CSSProperties, useContext, } from "react";
// 方法
import { DragDropContext } from "./context/dragDropContext";
import { getNumberSortArray } from "../utils/dataUtils";
// 常量
import { DragGridProps } from "./interface";

/** 网格 */
const DragGrid: FC<DragGridProps> = props => {
  const { width, height, grid, wrapHeight, } = useContext(DragDropContext);
  /** 网格行数 */
  const rowNumber = useMemo(() => {
    if (!wrapHeight || !height) return 1;
    return Math.ceil((wrapHeight + 1000) / height);
  }, [wrapHeight, height]);
  
  return (
    <>
      {
        getNumberSortArray(grid).map((_, index) => {
          const columnStyle: CSSProperties = {
            width,
            height: rowNumber * (height + 8),
            left: (8 * (index + 1)) + (width * index),
          };
          return (
            <div key={index} className="grid-column" style={columnStyle}></div>
          );
        })
      }
      {
        getNumberSortArray(rowNumber).map((_, index) => {
          const columnStyle: CSSProperties = {
            height,
            width: '100%',
            top: (8 * (index + 1)) + (height * index),
          };
          return (
            <div key={index} className="grid-row" style={columnStyle}></div>
          );
        })
      }
    </>
  );
};

export default DragGrid;
